var map = {
	"./action.svg": 75,
	"./add.svg": 12,
	"./address-location.svg": 13,
	"./arrow-down.svg": 14,
	"./arrow-to-left.svg": 76,
	"./arrow-to-right.svg": 15,
	"./arrow-to-top.svg": 77,
	"./arrow-up.svg": 16,
	"./arrow_right.svg": 78,
	"./arrows-back.svg": 17,
	"./avatar.svg": 79,
	"./back.svg": 80,
	"./checked.svg": 81,
	"./checked2.svg": 82,
	"./circle-cross.svg": 18,
	"./clear.svg": 83,
	"./close.svg": 84,
	"./collectic.svg": 85,
	"./cross.svg": 86,
	"./down.svg": 19,
	"./ellipsis.svg": 87,
	"./finish.svg": 20,
	"./github.svg": 88,
	"./hook-red.svg": 21,
	"./message.svg": 89,
	"./minus.svg": 90,
	"./more.svg": 91,
	"./more2.svg": 92,
	"./more3.svg": 93,
	"./nav.svg": 94,
	"./notice.svg": 95,
	"./plus.svg": 96,
	"./process.svg": 97,
	"./processed.svg": 98,
	"./qr.svg": 99,
	"./rate-default-img.svg": 100,
	"./reduce.svg": 22,
	"./right.svg": 101,
	"./search.svg": 102,
	"./search2.svg": 103,
	"./search3.svg": 104,
	"./set.svg": 105,
	"./share.svg": 106,
	"./star.svg": 107,
	"./tick-red.svg": 23,
	"./tick.svg": 108,
	"./top.svg": 109,
	"./trolley.svg": 110,
	"./unchecked.svg": 111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74;